import {Box, Text} from '@mantine/core';
import type React from 'react';
import {MdClose} from 'react-icons/md';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';

type Props = {
  closePopup: () => void;
};
export const OffereePromo: React.FC<Props> = ({closePopup}) => {
  const {isPC} = useMediaQuery();
  return (
    <>
      {isPC ? (
        <Box className="flex flex-row justify-between">
          <Box
            className="flex flex-row text-primary-2 items-center text-base cursor-pointer"
            onClick={closePopup}
          >
            <MdClose size={14} />
            <Text>閉じる</Text>
          </Box>
        </Box>
      ) : (
        <Box className="flex flex-row justify-between">
          <Box
            className="flex flex-row text-primary-2 items-center text-base cursor-pointer"
            onClick={closePopup}
          >
            <MdClose size={14} />
          </Box>
        </Box>
      )}
    </>
  );
};
